module.exports = __webpack_public_path__ + "img/1-sm.68b0fbec.jpg";